import { BREADCRUMB } from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import Breadcrumb from './index';

const module: ModulesList = {
  [BREADCRUMB]: {
    component: Breadcrumb,
  } as Module,
};

export default module;
